import React from "react";
import {
  ActivityIndicator,
  StyleProp,
  StyleSheet,
  TextInput,
  TextInputProps,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from "react-native";
import { Search, X } from "lucide-react";

type SearchInputProps = {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
  placeholderTextColor?: string;
  loading?: boolean;
  onClear?: () => void;
  showClearButton?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
  inputStyle?: StyleProp<TextStyle>;
  iconColor?: string;
  inputProps?: Omit<TextInputProps, "value" | "onChangeText" | "placeholder">;
};

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChangeText,
  placeholder = "Search",
  placeholderTextColor = "#999",
  loading = false,
  onClear,
  showClearButton = true,
  containerStyle,
  inputStyle,
  iconColor = "#777",
  inputProps,
}) => {
  const showClear = Boolean(showClearButton && value.length > 0 && !loading);

  return (
    <View style={[styles.container, containerStyle]}>
      <Search size={20} color={iconColor} style={styles.searchIcon} />
      <TextInput
        style={[styles.input, inputStyle]}
        placeholder={placeholder}
        value={value}
        onChangeText={onChangeText}
        placeholderTextColor={placeholderTextColor}
        {...inputProps}
      />
      {loading && <ActivityIndicator size="small" color="#0085FF" />}
      {showClear && (
        <TouchableOpacity
          onPress={onClear || (() => onChangeText(""))}
          style={styles.clearButton}
        >
          <X size={16} color="#999" />
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    backgroundColor: "#F5F5F5",
    borderRadius: 10,
    paddingHorizontal: 16,
    paddingVertical: 12,
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#EEEEEE",
    minWidth: 0,
  },
  searchIcon: {
    marginRight: 12,
    width: 20,
    height: 20,
  },
  input: {
    flex: 1,
    fontSize: 16,
    color: "#333333",
    minWidth: 0,
  },
  clearButton: {
    padding: 6,
  },
});

export default SearchInput;
